<template>
  <swiper-slide class="swiper5">

    <head-bar :main_title="main_title"
              :isT="1"></head-bar>
    <div class="container">
      <div id="app">
        <div class='viewport'>
          <div class="containWrap">
            <div class="left">
              <div class="leftTop">
                <div class="leftTopTitle bigTitle">市场下沉投放能力</div>
                <div class="leftTopContain">
                  <div v-show="lineType"
                       class="leftTopContain1">
                    <strong>400+</strong>地级市
                  </div>
                  <div v-show="!lineType"
                       class="leftTopContain2">
                    <strong>2800+</strong>区/县
                  </div>
                  <line-charts :lineData="data1"
                               @changeLineType='lineType = !lineType'></line-charts>
                  <!-- <line-charts :lineData='data1'></line-charts> -->
                  <img src="../assets/4brand/漂浮.png"
                       id="float1"
                       style="">
                  <img src="../assets/4brand/漂浮.png"
                       id="float2"
                       style="margin:-40px 170px 0;">

                </div>
              </div>
              <div class="lefBottom">
                <div class="leftBottomTitle bigTitle">透明化流量补充方案</div>
                <div class="leftBottomContain">
                  <div class="containLeft">
                    <div class="contain1">广告形式(开屏视频，信息流视频…)互动 率高，强势触达，有效传递品牌信息</div>
                    <div class="contain1">除BBAT外最大的移动库存,增量解决资源库存不足</div>
                  </div>
                  <div class="containCenter">
                    <div class="centerTextWrapper">
                      <div class="centerTextTop">
                        <span>高互动</span>
                        <span>触达新的用户</span>
                      </div>
                      <div class="centerTextBottom">
                        <span>新的库存增量</span>
                        <span>透明化支持</span>
                      </div>
                    </div>
                    <div class="arrowTop"></div>
                    <div class="arrowBottom"></div>
                    <div class="arrowLeft"></div>
                    <div class="arrowRight"></div>
                  </div>
                  <div class="containRight">
                    <div class="contan2">全场景覆盖消费者，帮助广告主触达缺失用户</div>
                    <div class="contan2">提供透明程序化PD采买模式，领先行业先进的反作弊技术，确保广告主在繁杂媒介环境中获取真实声量</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="center">
              <!-- <img src="../assets/4brand/中间.png"> -->
              <img src="../assets/4brand/左通风.png"
                   class="leftImg">
              <img src="../assets/4brand/右通风.png"
                   class="rightImg">
              <Earth></Earth>
            </div>
            <div class="right">
              <div class="rightTop">
                <div class="rightTopTitle bigTitle">再营销推广</div>
                <div class="tip">以优秀品牌资源和高品质用户为轴心</div>
                <div class="rightTopContain">
                  <div class="innerRound"></div>
                  <span>通过机器学习形成营销闭环</span>
                  <div class="text t1"
                       :class="{active:active==='active1'}"
                       @mouseleave="mouseleave"
                       @mouseenter="mouseenter(1)">高价值用户</div>
                  <div class="text t2"
                       @mouseenter="mouseenter(2)"
                       @mouseleave="mouseleave"
                       :class="{active:active==='active2'}">技术手段追击</div>
                  <div class="text t3"
                       @mouseenter="mouseenter(3)"
                       @mouseleave="mouseleave"
                       :class="{active:active==='active3'}">动态策略优化</div>
                  <div class="text t4"
                       @mouseenter="mouseenter(4)"
                       @mouseleave="mouseleave"
                       :class="{active:active==='active4'}">动态创意影响</div>
                  <div class="text t5"
                       @mouseenter="mouseenter(5)"
                       @mouseleave="mouseleave"
                       :class="{active:active==='active5'}">高质流量触达</div>
                  <div class="text t6"
                       @mouseenter="mouseenter(6)"
                       @mouseleave="mouseleave"
                       :class="{active:active==='active6'}">智能学习建模</div>
                  <div class="text t7"
                       @mouseenter="mouseenter(7)"
                       @mouseleave="mouseleave"
                       :class="{active:active==='active7'}">用户数据完善</div>
                  <div class="text t8"
                       @mouseleave="mouseleave"
                       @mouseenter="mouseenter(8)"
                       :class="{active:active==='active8'}">提升互动效果</div>
                </div>
              </div>
              <div class="rightBottom">
                <div class="rightBottomTitle bigTitle">数字营销</div>
                <div class="rightBottomContain">
                  <!-- <div class='boxWrap'>
                    <div class="text">技术引导</div>
                    <img src="../assets/4brand/内层通道.png"
                         class="img1">
                    <div class="img2"></div>

                    <div class="box1 after"></div>
                    <div class="box1"></div>
                    <div class="box1"></div>

                  </div>
                  <div class='boxBottomBg'>
                    <div>三大</div>
                    <div>核心支持</div>
                  </div>
                  <div class="boxBottom "></div>
                  <div class="boxBottom under"></div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </swiper-slide>
</template>

<script>
import headBar from "../components/headBar.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
import Earth from './earth.vue';
import lineCharts from './line.vue';
export default {
  name: "brandResource",
  components: {
    swiper,
    swiperSlide,
    headBar,
    Earth,
    lineCharts
  },
  data () {
    return {
      main_title: require("../assets/title4.png"),
      active: 'active1',
      index: 1,
      b: null, //在营销推广定时器
      lineType: false, //数据切换
      data1: [0, 132, 60, 334, 80, 160, 0], //400地级市折线图数据
      data2: [0, 20, 92, 30, 20, 40, 0], //2000区县数据
    }
  },
  created () {
    this.changeSize()
    this.changeCity()
  },
  methods: {
    changeCity () {
      this.lineType = this.data2
    },
    changeSize () {
      let a = setTimeout(() => {
        clearTimeout(a)
      }, 4000)

      this.b = setInterval(() => {
        if (this.index >= 9) this.index = 1
        this.active = `active${this.index}`
        this.index++
      }, 1600)
    },
    mouseenter (num) {
      this.index = num
      this.active = `active${num}`
      clearInterval(this.b)
    },
    mouseleave () {
      this.b = setInterval(() => {
        if (this.index >= 9) this.index = 1
        this.active = `active${this.index}`
        this.index++
      }, 1600)
    }
  }
}
</script>
<style lang="less">
//transparent  透明
@OutTipColor: red;
@InnerTipColor: green;

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.container {
  width: 100%;
  height: 100%;
  background: url("../assets/4brand/背景.png") no-repeat;
  background-size: 100% 100%;
}
ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.active {
  transition: all 0.3s;
  font-weight: bold;
  color: #ffb95f !important;
  transform: scale(1.3);
}
//大标题
.bigTitle:before {
  content: "";
  width: 27px;
  height: 27px;
  position: absolute;
  top: 9px;
  left: 11px;
  border: 1px solid #3d6ed9;
}
//标题呼吸灯
@keyframes flicker {
  0%,
  100% {
    background: #fffd99;
    box-shadow: 0 0 1rem #fefa01,
      inset -0.25rem 0 0 0.5rem rgba(14, 10, 10, 0.1);
  }
  30%,
  70% {
    background: #fe6f01;
    box-shadow: -1rem 0 8rem 1rem #fee501,
      inset -0.25rem 0 0 0.5rem rgba(14, 10, 10, 0.1);
  }
  50% {
    box-shadow: -1rem 0 8rem 1rem rgba(254, 250, 1, 0.8),
      inset -0.25rem 0 0 0.5rem rgba(14, 10, 10, 0.1);
  }
}
//标题滚动
@keyframes scoll {
  from {
    background-position: 0 0;
  }
  to {
    background-position: -273px 0;
  }
}
body {
  width: 100%;
  height: 100%;

  .viewport {
    overflow: hidden;
    // background: url(../assets/4brand/TOP.png) no-repeat 0 0 / contain;
    .containWrap {
      // background-color: red;
      width: 1860px;
      height: 1020px;
      margin: 30px;
      // border: 1px solid @OutTipColor;
      display: flex;
      .left {
        flex: 1;
        .leftTop {
          width: 100%;
          height: 528px;
          overflow: hidden;
          margin-top: 96px;
          // background-color: aquamarine;
          //左上标题
          .leftTopTitle {
            height: 41px;
            width: 273px;
            overflow: hidden;
            line-height: 48px;
            padding-left: 50px;
            font-size: 18px;
            font-weight: bold;
            color: #ffb95f;
            position: relative;
            // border: 1px solid red;
            background: url(../assets/4brand/标题1.png) repeat-x 0 0 / contain;
            animation: scoll 5s linear infinite;

            &:after {
              content: "";
              position: absolute;
              top: 19px;
              left: 21px;
              width: 10px;
              height: 10px;
              border-radius: 50%;

              background-color: #ffb95f;

              // background: url(../assets/4brand/椭圆点.png) no-repeat 0 0 / cover;
              background-position: -24px -80px;
              animation: flicker 3s ease infinite;
            }
          }
          .leftTopContain {
            width: 323px;
            height: 100%;
            margin-left: 45px;
            margin-top: 40px;
            color: #fff200;
            // border: 1px solid @OutTipColor;
            background: url(../assets/4brand/左上图标.png) no-repeat 0 0 /
              contain;
            @keyframes float1 {
              0% {
                transform: translateY(0);
              }
              100% {
                transform: translateY(-50px);
              }
            }
            #float1 {
              animation: float1 3s cubic-bezier(0.165, 0.84, 0.44, 1) infinite
                alternate;
            }
            #float2 {
              animation: float1 1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite
                alternate;
            }
            #float3 {
              animation: float1 4s cubic-bezier(0.165, 0.84, 0.24, 2) infinite
                alternate;
            }
            .leftTopContain1,
            .leftTopContain2 {
              height: 34px;
              width: 105px;
              line-height: 34px;
              text-align: center;
              border-radius: 5px;
              background-color: #0067b1;
              font-size: 7px;
              text-size-adjust: none;
            }
            .leftTopContain1 {
              margin-left: -10px;
              margin-top: 6px;
            }
            .leftTopContain2 {
              margin-left: 202px;
              margin-top: 28px;
            }
            strong {
              font-size: 20px;
            }
          }
        }
        .lefBottom {
          width: 100%;
          height: 100%;
          // border: 1px solid @OutTipColor;
          //左下标题
          .leftBottomTitle {
            height: 41px;
            width: 273px;
            line-height: 48px;
            padding-left: 50px;
            overflow: hidden;
            font-size: 18px;
            font-weight: bold;
            color: #ffb95f;
            background: url(../assets/4brand/标题1.png) repeat-x 0 0 / contain;
            position: relative;
            animation: scoll 5s linear infinite;
            &:after {
              content: "";
              position: absolute;
              top: 19px;
              left: 21px;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background-color: #ffb95f;
              box-shadow: 0 0 14px #5fff9c;
              opacity: 0.8;
              // background: url(../assets/4brand/椭圆点.png) no-repeat 0 0 / cover;
              background-position: -24px -80px;
              animation: flicker 3s ease infinite;
            }
          }
          .leftBottomContain {
            height: 290px;
            margin-top: 13px;
            // border: 1px solid @InnerTipColor;
            background: url(../assets/4brand/透明化流量.png) no-repeat 0 0 /
              contain;
            background-position: 164px 20px;
            display: flex;
            .containLeft {
              flex: 1;
              .contain1 {
                width: 165px;
                font-size: 12px;
                margin-top: 55px;
                color: #fff;
                padding: 16px 6px 10px 17px;
                background: url(../assets/4brand/透明背景左.png) no-repeat 0 0 /
                  cover;
              }
            }
            .containCenter {
              width: 234px;
              height: 100%;
              // border: 1px solid @OutTipColor;
              position: relative;
              .centerTextWrapper {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                color: #fff;
                font-size: 16px;
                font-weight: bold;
                // border: 1px solid @InnerTipColor;
                .centerTextTop {
                  display: flex;
                  margin: 18px;
                  justify-content: space-between;
                  align-items: flex-end;
                  flex: 1;
                  span {
                    text-align: center;
                    width: 50px;
                  }
                }
                .centerTextBottom {
                  display: flex;
                  margin: 90px 20px 0;
                  justify-content: space-between;
                  align-items: center;
                  flex: 1;
                  span {
                    text-align: center;
                    width: 50px;
                  }
                }
              }
              & > div {
                width: 22px;
                height: 28px;
                position: absolute;
              }
              @keyframes moveLeft {
                from {
                  left: 38px;
                }
                to {
                  left: 28px;
                }
              }
              @keyframes moveRight {
                from {
                  left: 180px;
                }
                to {
                  left: 190px;
                }
              }
              @keyframes moveTop {
                from {
                  top: 80px;
                }
                to {
                  top: 70px;
                }
              }
              @keyframes moveBottom {
                from {
                  top: 226px;
                }
                to {
                  top: 236px;
                }
              }
              .arrowTop {
                top: 80px;
                left: 108px;
                transform: rotate(180deg);
                animation: moveTop 1.5s infinite;
                background: url(../assets/4brand/箭头.png) no-repeat 0 0 /
                  contain;
              }
              .arrowBottom {
                top: 226px;
                left: 108px;
                animation: moveBottom 1.5s infinite;
                background: url(../assets/4brand/箭头.png) no-repeat 0 0 /
                  contain;
              }
              .arrowLeft {
                top: 150px;
                left: 38px;
                transform: rotate(90deg);
                animation: moveLeft 1.5s infinite;
                background: url(../assets/4brand/箭头.png) no-repeat 0 0 /
                  contain;
              }
              .arrowRight {
                top: 150px;
                left: 190px;
                transform: rotate(-90deg);
                animation: moveRight 1.5s infinite;
                background: url(../assets/4brand/箭头.png) no-repeat 0 0 /
                  contain;
              }
            }
            .containRight {
              flex: 1;
              .contan2 {
                width: 165px;
                font-size: 12px;
                margin-top: 45px;
                margin-left: 27px;
                color: #fff;
                padding: 16px 17px 10px 6px;
                background: url(../assets/4brand/透明背景右.png) no-repeat 0 0 /
                  cover;
              }
            }
          }
        }
      }
      //中间
      .center {
        width: 624px;
        // border: 1px solid @OutTipColor;
        background: url(../assets/4brand/中间.png) no-repeat 0 0 / contain;
        background-position: 0 150px;

        img {
          width: 100%;
          margin-top: 144px;
        }
        .leftImg {
          width: 350px;
          height: 273px;
          top: 210px;
          left: 297px;
          position: absolute;
        }
        .rightImg {
          width: 350px;
          height: 273px;
          top: 210px;
          right: 297px;
          position: absolute;
        }
        .earth {
          width: 100%;
          height: 300px;
          position: absolute;
        }
      }
      .right {
        flex: 1;
        .rightTop {
          width: 100%;
          height: 528px;
          overflow: hidden;
          margin-top: 96px;
          position: relative;
          // border: 1px solid @InnerTipColor;
          //右上标题
          .rightTopTitle {
            height: 41px;
            width: 273px;
            margin-left: 340px;
            line-height: 48px;
            padding-left: 50px;
            font-size: 18px;
            font-weight: bold;
            color: #ffb95f;
            position: relative;
            overflow: hidden;
            background: url(../assets/4brand/标题1.png) repeat-x 0 0 / contain;
            animation: scoll 5s linear infinite;
            &:after {
              content: "";
              position: absolute;
              top: 19px;
              left: 21px;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background-color: #ffb95f;
              box-shadow: 0 0 14px #5fff9c;
              opacity: 0.8;
              // background: url(../assets/4brand/椭圆点.png) no-repeat 0 0 / cover;
              background-position: -24px -80px;
              animation: flicker 3s ease infinite;
            }
          }
          .tip {
            position: absolute;
            right: 35px;
            top: 57px;
            color: #00fcff;
            font-size: 16px;
            font-weight: bold;
          }
          .rightTopContain {
            width: 432px;
            height: 100%;
            margin-top: 42px;
            margin-left: 189px;
            // border: 1px solid @InnerTipColor;
            background: url(../assets/4brand/外圈箭头.png) no-repeat 102px 42px;
            background-size: 227px 227px;
            position: relative;
            overflow: hidden;
            .innerRound {
              width: 121px;
              height: 121px;
              margin: 95px 37% 0;
              // border: 1px solid @OutTipColor;
              background: url(../assets/4brand/内圈箭头.png) no-repeat center
                center;
              background-size: 121px 121px;
              animation: innerRound 12.5s linear infinite;

              @keyframes innerRound {
                from {
                  transform: rotate(0deg);
                }
                to {
                  transform: rotate(360deg);
                }
              }
            }
            & span {
              margin: -98px 191px;
              width: 60px;
              display: block;
              // border: 1px solid @InnerTipColor;
              font-size: 12px;
              color: #ffd900;
              // font-weight: bold;
              text-align: center;
            }
            .text {
              border-radius: 5px;
              height: 32px;
              position: absolute;
              color: #fff;
              padding: 4px;
              background-color: #5765b5;
              transition: all 0.3s;
              &:hover {
                font-weight: bold;
                color: #ffb95f !important;
                transform: scale(1.3);
                cursor: pointer;
              }
            }
            .t1 {
              top: 35px;
              left: 176px;
            }
            .t2 {
              top: 85px;
              left: 274px;
            }
            .t3 {
              top: 145px;
              left: 294px;
            }
            .t4 {
              top: 205px;
              left: 274px;
            }
            .t5 {
              top: 245px;
              left: 170px;
            }
            .t6 {
              top: 205px;
              left: 50px;
            }
            .t7 {
              top: 145px;
              left: 35px;
            }
            .t8 {
              top: 85px;
              left: 65px;
            }
          }
        }
        .rightBottom {
          // border: 1px solid @InnerTipColor;
          //右下标题
          .rightBottomTitle {
            height: 41px;
            width: 273px;
            margin-left: 340px;
            line-height: 48px;
            padding-left: 50px;
            font-size: 18px;
            font-weight: bold;
            color: #ffb95f;
            position: relative;
            overflow: hidden;
            background: url(../assets/4brand/标题1.png) repeat-x 0 0 / contain;
            animation: scoll 5s linear infinite;
            &:after {
              content: "";
              position: absolute;
              top: 19px;
              left: 21px;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              opacity: 0.8;
              // background: url(../assets/4brand/椭圆点.png) no-repeat 0 0 / cover;
              background-position: -24px -80px;
              animation: flicker 3s ease infinite;
            }
          }
          .rightBottomContain {
            // border: 1px solid @OutTipColor;
            height: 250px;
            width: 100%;
            position: relative;
            background: url(../assets/4brand/数字营销.png) no-repeat 70px 0 /
              contain;
            .boxWrap {
              height: 300px;
              width: 300px;
              margin-left: 144px;
              transform: rotate(-90deg);
              // border: 1px solid @InnerTipColor;
              position: relative;
              z-index: 99999;
              .after {
                &:after {
                  content: "";
                  display: inline-block;
                  background: rgb(0, 40, 124);

                  position: absolute;
                  top: 48%;
                  left: 48%;
                  width: 90px;
                  height: 90px;
                  transform: translate(-45px, -45px);
                  border: solid 2px rgb(13, 70, 174);
                  border-radius: 100px;
                }
              }
              .box1 {
                margin-left: 100px;
                width: 133px;
                height: 133px;
                border: solid 2px rgb(13, 70, 174);
                background: rgb(0, 26, 97);
                border-radius: 100px;
                position: relative;
                transform: rotateX(65deg);
                z-index: 1;
                &:before {
                  content: "";
                  display: inline-block;
                  width: 128px;
                  height: 200px;
                  position: absolute;
                  opacity: 0.5;
                  background: rgba(0, 26, 97, 1);
                  // background: rgb(10, 70, 235);
                  top: 50%;
                  left: -1px;
                  z-index: -9999;
                  border-left: rgb(0, 26, 97) 0.5px solid;
                  border-right: rgb(0, 26, 97) solid;
                  border-bottom: rgb(0, 26, 97) solid;
                  border-bottom-left-radius: 100px;
                  border-bottom-right-radius: 100px;
                }
              }
              .text {
                // border: 1px solid @InnerTipColor;
                transform: rotate(90deg);
                width: 20px;
                color: #fff;
                position: absolute;
                z-index: 99999;
                top: 205px;
                left: 155px;
                font-size: 18px;
                font-weight: bold;
              }
              &:after {
                content: "技术支持";
                // border: 1px solid @InnerTipColor;
                transform: rotate(90deg);
                width: 20px;
                color: #fff;
                position: absolute;
                z-index: 99999;
                top: 75px;
                left: 155px;
                font-size: 18px;
                font-weight: bold;
              }
              &:before {
                content: "流量落地";
                // border: 1px solid @InnerTipColor;
                transform: rotate(90deg);
                width: 20px;
                color: #fff;
                position: absolute;
                top: 335px;
                z-index: 99999 !important;
                left: 155px;
                font-size: 18px;
                font-weight: bold;
              }
              .img1 {
                position: absolute;
                transform: rotate(90deg);
                left: 0;
                top: 197px;
                z-index: 1;
                width: 325px;
                height: 90px;
              }
              .img2 {
                width: 510px;
                height: 190px;
                // border: 1px solid @OutTipColor;
                position: absolute;
                transform: rotate(90deg);
                left: -70px;
                top: 110px;
                background: url(../assets/4brand/大通道.png) no-repeat 0 0 /
                  contain;
                z-index: -999999 !important;
              }
            }
            .boxBottomBg {
              width: 304px;
              height: 64px;
              // border: 1px solid @OutTipColor;
              background: url(../assets/4brand/三大核心背景.png) no-repeat;
              position: absolute;
              top: 200px;
              left: 210px;
              opacity: 1;
              z-index: 999999;
              color: #ffb95f;
              font-size: 20px;
              div {
                text-align: center;
              }
            }
            .boxBottom {
              width: 303px;
              height: 26px;
              border: solid 2px rgb(13, 70, 174);
              border-radius: 50%;
              position: absolute;
              top: 250px;
              left: 210px;
              z-index: 999;
              background: -webkit-linear-gradient(
                top,
                #0045aa,
                #021b43
              ); /* Safari 5.1 - 6.0 */
              background: -o-linear-gradient(
                top,
                #0045aa,
                #021b43
              ); /* Opera 11.1 - 12.0 */
              background: -moz-linear-gradient(
                top,
                #0045aa,
                #021b43
              ); /* Firefox 3.6 - 15 */
              background: linear-gradient(
                top,
                #0045aa,
                #021b43
              ); /* 标准的语法（必须放在最后） */
            }
            .under {
              top: 265px;
              z-index: 1;
              opacity: 0.6;
            }
          }
        }
      }
    }
  }
}
</style>

